import Head from 'next/head';
import DefaultLayout from 'Components/layouts/default';
import styles from 'Components/pages/Promotions/PromoPost/PromoPost.module.scss';
import parse from 'html-react-parser';
import { EComponentVisibility } from '@spinwise/react-component-library/Global';
import { internalFetch } from '../../utils';
import BlockManager from 'Components/shared/StrapiBlockManager';
import { t } from 'i18next';

export async function getServerSideProps(context) {
  const res = await internalFetch(
    `/api/content/promotions?locale=${context.locale}&populate=deep&filters[brand][slug]=winnerz&filters[slug]=${context.query.promo}&geo=${context?.req?.cookies?.country}`,
    {
      country: context?.req?.cookies?.country,
    },
  );
  const { data = null } = res;

  if (data && data?.length == 0) {
    return {
      props: {},
      notFound: true,
    };
  }

  return {
    props: { data, pageSlug: context?.query?.promo?.replace(/-/g, '.') },
  };
}

export default function PromoModalPage(props) {
  const data = props.data[0]?.attributes ?? null;

  return (
    <>
      <Head>
        <title>{t(`page.promo.${props?.pageSlug}.meta.title`)}</title>
        <meta name="description" content={t(`page.promo.${props?.pageSlug}.meta.description`)} />
      </Head>
      <DefaultLayout>
        {data && (
          <>
            <div className="container-app">
              {data.styles && (
                <style jsx>{`
                  ${data?.styles?.css}
                `}</style>
              )}
              <div className={`${styles.modal} ${styles.modal_page}`}>
                <div className={`${EComponentVisibility.TableteDesktop}`}>
                  <img
                    src={data.image?.data?.attributes?.url}
                    alt=""
                    width="0"
                    height="0"
                    sizes="100vw"
                    style={{
                      width: '100%',
                      height: '330px',
                      objectFit: 'cover',
                    }}
                  />
                </div>
                <div className={`${EComponentVisibility.MobileOnly}`}>
                  <img
                    src={data.mobile_image.data.attributes.url}
                    alt=""
                    width="0"
                    height="0"
                    sizes="100vw"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </div>
                <div className={styles.modal_content}>
                  <div className={styles.modal_content_header}>
                    <span className={styles.modal_content_header__title}>{data.title}</span>
                    <br></br>
                    <span className={styles.modal_content_header__subtitle}>{data.subtitle}</span>
                  </div>
                  <div className={styles.modal_content__description}>{parse(data.description)}</div>
                  <BlockManager blocks={data.blocks}></BlockManager>
                </div>
              </div>
            </div>
          </>
        )}
      </DefaultLayout>
    </>
  );
}
